import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { myExpariencesService } from "../../services";
import { useSelector } from "react-redux";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  Paper,
  styled,
  Typography,
} from "@mui/material";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import { useTranslation } from "react-i18next";
import { KeyboardReturn } from "@mui/icons-material";
import PurchaseGeolocHeader from "../../components/purchaseGeoloc/PurchaseGeolocHeader";
import PurchaseGeolocInfos from "../../components/purchaseGeoloc/PurchaseGeolocInfos";
import PurchaseGeolocMap from "../../components/purchaseGeoloc/PurchaseGeolocMap";
import AuthDialog from "../../components/common/AuthDialog";
import Footer from "../../components/footer/Footer";

const PREFIX = "PurchaseGeoloc";

const classes = {
  loadingContainer: `${PREFIX}-loadingContainer`,
  loadingInfosContainer: `${PREFIX}-loadingInfosContainer`,
  loadingInfosTitle: `${PREFIX}-loadingInfosTitle`,
  purchaseButtonContainer: `${PREFIX}-purchaseButtonContainer`,
  purchaseButton: `${PREFIX}-purchaseButton`,
};

const PurchaseGeolocContainer = styled("div")(({ theme }) => ({
  maxWidth: "800px",
  margin: "0 auto",
  [theme.breakpoints.down("md")]: {
    maxWidth: "100%",
  },

  [`& .${classes.loadingContainer}`]: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "#303030",
    zIndex: 9999,
    overflow: "hidden",
  },

  [`& .${classes.loadingInfosContainer}`]: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    position: "absolute",
    top: "50%",
    right: "50%",
    transform: "translate(50%, -50%)",
  },

  [`& .${classes.loadingInfosTitle}`]: {
    marginBottom: "20px",
  },

  [`& .${classes.purchaseButtonContainer}`]: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },

  [`& .${classes.purchaseButton}`]: {
    margin: "20px 0",
  },
}));

const INITIAL_VIEW_STATE = {
  longitude: 2.35,
  latitude: 48.85,
};

const PurchaseGeoloc = () => {
  const { t } = useTranslation();
  const { id } = useParams();

  const isAdmin = useSelector(
    (state) => state.user?.currentUser?.account?.role === "ADMIN"
  );
  const loggedIn = useSelector((state) => state.user.loggedIn);

  const [exparienceData, setExparienceData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [displayMap, setDisplayMap] = useState(false);
  const [logginModal, setLoginModal] = useState(false);

  useEffect(() => {
    const getData = async () => {
      try {
        const data =
          await myExpariencesService.fetchPurchasedGeolocsSingleExparience(id);
        console.log(data);
        setExparienceData(data);
      } catch (error) {
        console.error("Error fetching experience:", error);
      } finally {
        const timeoutId = setTimeout(() => {
          setLoading(false);
        }, 400);
        return () => clearTimeout(timeoutId);
      }
    };

    if (id) {
      getData();
    }
  }, [id]);

  const handleOpenLogginModal = () => {
    if (loggedIn) {
      setDisplayMap(!displayMap);
    } else {
      setLoginModal(true);
    }
  };

  return (
    <PurchaseGeolocContainer>
      {loading && (
        <Box className={classes.loadingContainer}>
          <Box className={classes.loadingInfosContainer}>
            <Typography variant="h3" className={classes.loadingInfosTitle}>
              {t("purchaseGeoloc.loading")}
            </Typography>
            <CircularProgress color="primary" />
          </Box>
        </Box>
      )}
      <PurchaseGeolocHeader exparienceData={exparienceData} />
      <Paper elevation={3} className={classes.purchaseButtonContainer}>
        {displayMap ? (
          <Button
            variant="contained"
            startIcon={<KeyboardReturn />}
            className={classes.purchaseButton}
            onClick={handleOpenLogginModal}
          >
            {t("purchaseGeoloc.exparienceInfos")}
          </Button>
        ) : (
          <Button
            variant="contained"
            startIcon={<AddShoppingCartIcon />}
            className={classes.purchaseButton}
            onClick={handleOpenLogginModal}
          >
            {t("purchaseGeoloc.buyGeoloc")}
          </Button>
        )}
      </Paper>
      {!displayMap ? (
        <PurchaseGeolocInfos exparienceData={exparienceData} />
      ) : (
        <PurchaseGeolocMap
          initialViewState={INITIAL_VIEW_STATE}
          exparienceID={id}
          priceGeoloc={exparienceData?.priceGeoloc}
          mapID="purchaseGeolocMap"
          alreadyPurchased={exparienceData?.alreadyPurchased}
        />
      )}
      <Dialog onClose={() => setLoginModal(false)} open={logginModal}>
        <AuthDialog
          origin={"purchaseGeoloc"}
          exparienceID={id}
          setLoginModal={setLoginModal}
        />
      </Dialog>
      <Footer />
    </PurchaseGeolocContainer>
  );
};

export default PurchaseGeoloc;
